import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-default-date",
  templateUrl: "./field-set-default-date.component.html",
  styles: [],
})
export class FieldSetDefaultDateComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event: any) {
    this.dataChanged.emit(event);
  }
}
